import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
// import 'firebase/firestore'
import 'firebase/performance'

const config = {
  apiKey: 'AIzaSyBBalzlfDwAe53QcMNvY_PmVJ54ZWl5vVk',
  authDomain: 'gyshitt.firebaseapp.com',
  databaseURL: 'https://gyshitt.firebaseio.com',
  projectId: 'gyshitt',
  storageBucket: 'gyshitt.appspot.com',
  messagingSenderId: '13111219009',
  appId: '1:13111219009:web:169e70393e0eb1018687c0',
  measurementId: 'G-0YDJZJLE4V'
}
firebase.initializeApp(config)
firebase.analytics()
firebase.performance()

// const db = firebase.firestore()
const auth = firebase.auth
// const db = firebase.firestore()
// db.enablePersistence().catch(error => {
//   console.error('Firestore Persistence cannot be enabled!')
//   console.error(error)
// })

export default {
  // db,
  auth
}
